import { Users, Radio, Link2, Building2, ClipboardList } from "lucide-react";

export const LIMIT_META = {
  max_users: { label: "Usuários", icon: Users },
  max_channels: { label: "Canais", icon: Radio },
  max_connections: { label: "Conexões", icon: Link2 },
  max_sectors: { label: "Departamentos", icon: Building2 },
  max_os: { label: "OS em aberto", icon: ClipboardList },
};

export function LimitsBar({ usage, keys = Object.keys(LIMIT_META), compact = false, testId = "limits-bar" }) {
  if (!usage) return null;
  return (
    <div className={`flex flex-wrap ${compact ? "gap-x-3 gap-y-1" : "gap-3"}`} data-testid={testId}>
      {keys.map((k) => {
        const u = usage[k];
        if (!u) return null;
        const { label, icon: Icon } = LIMIT_META[k];
        const pct = u.limit ? Math.min(100, Math.round((u.used / u.limit) * 100)) : 0;
        const tone = u.reached ? "text-rose-600" : pct >= 80 ? "text-amber-600" : "text-slate-600 dark:text-slate-300";
        return (
          <div key={k} className={`${compact ? "text-xs" : "text-sm min-w-[140px]"} ${tone}`} data-testid={`limit-${k}`} title={label}>
            <span className="flex items-center gap-1 font-medium">
              <Icon className="w-3.5 h-3.5" /> {label}: <b>{u.used}</b> / {u.limit ? u.limit : "∞"}
            </span>
            {!compact && (
              <div className="h-1.5 mt-1 rounded-full bg-slate-200 dark:bg-slate-700 overflow-hidden">
                <div className={`h-full rounded-full ${u.reached ? "bg-rose-500" : pct >= 80 ? "bg-amber-500" : "bg-emerald-500"}`} style={{ width: `${u.limit ? pct : 0}%` }} />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
